import { useState, useEffect } from 'react'
import api from '../api/client'
import Modal from './Modal'
import Boton from './Boton'

const money = n => '$ ' + (parseFloat(n) || 0).toLocaleString('es-AR', { minimumFractionDigits: 2, maximumFractionDigits: 2 })

/**
 * Muestra TODOS los precios de un artículo (uno por lista) para que el vendedor elija.
 * Se usa cuando el usuario no tiene una lista fija asignada.
 * Props: articulo {id, descripcion, codigo_alfa}, listaClienteNombre (opcional, para resaltar),
 *        onElegir(precio|null, listaInfo), onClose.
 */
export default function ModalPreciosArticulo({ articulo, listaClienteNombre, onElegir, onClose }) {
  const [precios, setPrecios] = useState(null)

  useEffect(() => {
    api.get(`/articulos/${articulo.id}/precios`)
      .then(({ data }) => setPrecios(Array.isArray(data) ? data : []))
      .catch(() => setPrecios([]))
  }, [articulo.id])

  return (
    <Modal title={`Precios — ${articulo.descripcion}`} onClose={onClose} maxWidth="460px">
      <p style={st.sub}><b>{articulo.codigo_alfa}</b> · elegí de qué lista tomar el precio</p>

      {!precios ? (
        <p style={st.muted}>Cargando precios…</p>
      ) : precios.length === 0 ? (
        <div style={{ textAlign: 'center', padding: '0.5rem' }}>
          <p style={st.muted}>Este artículo no tiene precio en ninguna lista.</p>
          <Boton variante="secondary" style={{ marginTop: '0.5rem' }} onClick={() => onElegir(null, null)}>Cargar precio a mano</Boton>
        </div>
      ) : (
        <table style={st.tabla}>
          <thead><tr><th style={st.th}>Lista</th><th style={{ ...st.th, textAlign: 'right' }}>Precio</th><th style={st.th}></th></tr></thead>
          <tbody>
            {precios.map(p => {
              const esCli = listaClienteNombre && p.lista_nombre === listaClienteNombre
              return (
                <tr key={p.lista_id} style={esCli ? st.trCli : st.tr}>
                  <td style={st.td}>{p.lista_nombre}{esCli && <span style={st.tag}>cliente</span>}</td>
                  <td style={{ ...st.td, textAlign: 'right', fontVariantNumeric: 'tabular-nums', fontWeight: 600 }}>{money(p.precio)}</td>
                  <td style={{ ...st.td, textAlign: 'right' }}>
                    <Boton variante="primary" sm onClick={() => onElegir(parseFloat(p.precio), p)}>Usar</Boton>
                  </td>
                </tr>
              )
            })}
          </tbody>
        </table>
      )}
    </Modal>
  )
}

const st = {
  sub: { margin: '0 0 0.8rem', fontSize: '0.85rem', color: '#475569' },
  muted: { color: '#94a3b8', fontSize: '0.9rem', textAlign: 'center', padding: '0.5rem' },
  tabla: { width: '100%', borderCollapse: 'collapse', fontSize: '0.9rem' },
  th: { padding: '0.4rem 0.5rem', textAlign: 'left', fontSize: '0.72rem', textTransform: 'uppercase', color: '#64748b', borderBottom: '1px solid #e2e8f0', letterSpacing: '.03em' },
  tr: { borderBottom: '1px solid #f1f5f9' },
  trCli: { borderBottom: '1px solid #f1f5f9', background: '#eff6ff' },
  td: { padding: '0.45rem 0.5rem', verticalAlign: 'middle' },
  tag: { marginLeft: 6, fontSize: '0.62rem', fontWeight: 800, color: '#1e40af', background: '#dbeafe', padding: '1px 6px', borderRadius: 8, textTransform: 'uppercase' },
}
